/** Reports page copy. EN mirrors SV until proper translations are added. */
export const reportsTranslationsSv = {
    title: 'Rapporter',
    contactPrefix: 'Du når oss på ',
    contactSuffix: '.',
}
